import { ArrowRight } from 'lucide-react';
import { Button } from './ui/button';
import { Link } from 'react-router-dom';
import namport from '@/assets/namport.jpg';

const HeroSection = () => {
  return (
    <section 
      className="relative min-h-[100vh] flex flex-col items-center justify-center text-center text-white overflow-hidden"
      style={{ backgroundImage: `url(${namport})`, backgroundSize: 'cover', backgroundPosition: 'center' }}
    >
      {/* Dark Overlay */}
      <div className="absolute inset-0 bg-black/60 z-10"></div>

      {/* Content */}
      <div className="relative z-20 container mx-auto px-4 md:px-6 animate-fade-in-up">
        <h1 className="text-5xl md:text-6xl lg:text-7xl font-extrabold leading-tight mb-4">
          <span className="bg-gradient-to-r from-seafarer-orange to-seafarer-purple text-transparent bg-clip-text">
            Restoring Dignity
          </span>
          <br />
          for Every Seafarer
        </h1>
        <p className="text-lg md:text-xl text-gray-200 mb-8 max-w-2xl mx-auto">
          A dedicated platform for fishermen to secure land, housing, and build a sustainable future through collaboration and shared ideas.
        </p>
        <div className="flex flex-col sm:flex-row gap-4 justify-center">
          <Button asChild size="lg" className="seafarer-btn-primary shadow-lg transform hover:scale-105 transition-transform duration-300">
            <Link to="/about">
              Discover Our Mission <ArrowRight size={20} className="ml-2" />
            </Link>
          </Button>
          <Button asChild size="lg" variant="secondary" className="bg-white/10 backdrop-blur-sm border border-white/20 hover:bg-white/20 transform hover:scale-105 transition-transform duration-300">
            <Link to="/contact">Join the Federation</Link>
          </Button>
        </div>
      </div>
    </section>
  );
};

export default HeroSection;
